import axios from 'axios';

export const capitalize = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const translatePlural = (singularText, pluralText, value) => {
	return value > 1 ? pluralText : singularText;
};

export const isValidName = (name) => {
	if (!name || typeof name !== 'string') {
		return false;
	}
	
	if (name.trim().length === 0) {
		return false;
	}
	
	// Allow everything else - letters, numbers, spaces, special characters, trailing spaces
	return true;
};

export const downloadFile = (url, query) => {
	return new Promise((resolve, reject) => {
		axios
			.get(url, {
				params: query || {},
				responseType: 'blob', // Set the response type to 'blob'
			})
			.then((response) => {
				// Get the content-disposition header from the response
				const contentDisposition = response.headers['content-disposition'];
				// Extract the filename from the content-disposition header
				const filename = contentDisposition
					.split(';')
					.find((part) => part.trim().startsWith('filename='))
					.split('=')[1]
					.trim();

				// Create a blob URL for the file response
				const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
				// Create a temporary anchor element to trigger the download
				const link = document.createElement('a');
				link.href = fileUrl;
				link.setAttribute('download', filename); // Set the desired file name
				document.body.appendChild(link);
				link.click();
				// Clean up after the download
				window.URL.revokeObjectURL(fileUrl);
				resolve();
			})
			.catch((error) => {
				console.error('File download error:', error);
				reject(error);
			});
	});
};

export const maskSensitiveCredentials = (credentials) => {
	if (!credentials || typeof credentials !== 'object') {
		return credentials;
	}

	const maskedCredentials = {};
	
	Object.entries(credentials).forEach(([key, value]) => {
		// Function to determine if field should be masked
		const shouldMaskField = (fieldName) => {
			const lowerKey = fieldName.toLowerCase();
			
			// Fields to keep visible (username/email/login identifiers only)
			const visibleFields = [
				'username', 'email', 'user', 'login', 'id', 'userid', 'user_id',
				'mail', 'loginid', 'login_id', 'account', 'accountname', 'identifier'
			];
			
			// Check if it's explicitly a visible field
			const isVisible = visibleFields.some(visible => lowerKey.includes(visible));
			if (isVisible) return false;
			
			// Default: mask all other fields (passwords, pins, etc.)
			return true;
		};

		maskedCredentials[key] = shouldMaskField(key) ? '**********' : value;
	});

	return maskedCredentials;
};

// Mirrors the backend rule in app/utils/license.js: only client-facing tenants
// hold a licence window, so the platform ('owner') and MSSP orgs never expire.
// Use this everywhere expiry is surfaced — deriving it inline from expireAt is
// what made the users list wrongly flag the platform org as expired.
export const isTenantLicenseExpired = (customer) =>
	!!(
		customer &&
		customer.customerType !== 'owner' &&
		customer.customerType !== 'mssp' &&
		customer.expireAt &&
		new Date(customer.expireAt).getTime() < Date.now()
	);

